// This disables Server-Side Rendering for the entire application.
// It forces all pages to be rendered only on the client-side.
export const ssr = false;
